// extracted by mini-css-extract-plugin
export var centerText = "_e0-8";
export var container = "_e0-0";
export var doughnutContainer = "_e0-7";
export var legend = "_e0-a";
export var legendItemColorDisplay = "_e0-b";
export var legendItemLabel = "_e0-d";
export var legendItemValue = "_e0-c";
export var lg = "_e0-5";
export var maxWidth = "_e0-9";
export var md = "_e0-4";
export var responsive = "_e0-6";
export var sm = "_e0-3";
export var xs = "_e0-2";
export var xxs = "_e0-1";